(function() {
  jQuery(function($) {
    var $el = $('.orderPhoneOnly')
    $(window).on('scroll', function() {
      var scrollHeight = $(document).height();
      var scrollPosition = $(window).height() + $(window).scrollTop();

      if ($el.length) {
        if ((scrollHeight - scrollPosition) / scrollHeight <= 0.05) {
          // 数値は状態判定をして取得した方がベターだけど、挙動が安定しないので数値で設定しておく
          $el.css('transform', 'translate(-350px)');
        } else {
          $el.css('transform', '');
        }
      }
    });
  });
})();
